<template>
    <div>
        <label v-if="label != ''" v-bind:for="id">{{ label }}</label>
        <input type="text" v-mask="['###########']" v-bind:class="classe" :value="value" v-bind:name="name" v-bind:id="id" v-bind:placeholder="placeholder" v-bind:required="required" v-bind:disabled="disabled" />
    </div>
</template>

<script>

    import { mask } from 'vue-the-mask'

    export default {
        name: 'input-number',
        directives: { mask },
        props: {
            options: {
                type: Object,
                default: () => ({}),
            }
        },
        
        data() {

            return {
                name: (this.options.name) ? this.options.name : 'number',
                id: (this.options.id) ? this.options.id : 'number',
                value: (this.options.value) ? this.options.value : '',
                placeholder: (this.options.placeholder) ? this.options.placeholder : '',
                label: (this.options.label) ? this.options.label : '',
                classe: (this.options.class) ? 'form-control ' + this.options.class : 'form-control',
                required: (this.options.required) ? this.options.required : false,
                disabled: (this.options.disabled) ? this.options.disabled : false,

            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Number.vue